import makeFormField from '@/components/formFields/makeFormField';
import DatePickerControl from '@/components/formControls/DatePicker';
import SelectListControl from '@/components/formControls/SelectList';
import CurrencyBoxControl from '@/components/formControls/CurrencyBox';
import TextAreaControl from '@/components/formControls/TextArea';
import TextBoxControl from '@/components/formControls/TextBox';

export const DatePicker = makeFormField(DatePickerControl);
export const SelectList = makeFormField(SelectListControl);
export const CurrencyBox = makeFormField(CurrencyBoxControl);
export const TextArea = makeFormField(TextAreaControl);
export const TextBox = makeFormField(TextBoxControl);
